/* Manual, progressively enhanced placements. No timers or third-party code. */
if (!customElements.get('sx-home-ads')) {
  customElements.define('sx-home-ads', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controls = Array.from(this.querySelectorAll('[data-ad-control]'));
      this.panels = Array.from(this.querySelectorAll('[data-ad-panel]'));
      this.classList.add('is-enhanced');
      this.controls.forEach((button, index) => button.addEventListener('click', () => this.select(index)));
      this.select(0);
      this.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel === event.target || panel.contains(event.target));
        if (index >= 0) this.select(index);
      });
    }
    select(index) {
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      this.controls.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index)));
    }
  });
}
/* Add standard arrow-key navigation without replacing the canonical tab renderer. */
function syncHomepageStandingsTabs(root = document) {
  root.querySelectorAll('.standings-preview__tab-buttons').forEach(group => {
    group.querySelectorAll('[data-tab-trigger]').forEach(button => {
      button.tabIndex = button.getAttribute('aria-selected') === 'true' ? 0 : -1;
    });
  });
}
syncHomepageStandingsTabs();
document.addEventListener('shopify:section:load', event => syncHomepageStandingsTabs(event.target));
document.addEventListener('click', event => {
  if (event.target.closest('[data-tab-trigger]')) syncHomepageStandingsTabs();
});
document.addEventListener('keydown', event => {
  const button = event.target.closest('[data-tab-trigger]');
  if (!button) return;
  const group = button.closest('.standings-preview__tab-buttons');
  if (!group) return;
  const buttons = Array.from(group.querySelectorAll('[data-tab-trigger]'));
  const index = buttons.indexOf(button);
  let next;
  if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
  if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
  if (event.key === 'Home') next = 0;
  if (event.key === 'End') next = buttons.length - 1;
  if (next !== undefined) {
    event.preventDefault();
    buttons[next].focus();
    buttons[next].click();
  }
});
